import { render, staticRenderFns } from "./notice-main.vue?vue&type=template&id=188b5ada&scoped=true&"
import script from "./notice-main.vue?vue&type=script&lang=js&"
export * from "./notice-main.vue?vue&type=script&lang=js&"
import style0 from "./notice-main.vue?vue&type=style&index=0&id=188b5ada&scoped=true&lang=css&"
import style1 from "./notice-main.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b5ada",
  null
  
)

export default component.exports